<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>

              <template slot="header">

                <v-toolbar class="active" :height="44" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text">{{ $t('sessions') }}</span>
                  </v-toolbar-title>
                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pa-0 >

                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    :subscribed="false"
                    :headUppercase="false"
                    :translate="true"
                    :hideValues="['undefined', 'null']"
                    @select=""
                    @value=""
                    @remove="(payload) => onRemove(payload)"
                  />

                </v-layout>

              </template>

            </scroll-area>

          </v-layout>
        </v-flex>
        
      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import { mapGetters } from 'vuex'

// Типы
interface UserSession {
  id?: string
  userId?: string
  expires?: string | Date
  roles?: string | string[]
  ip?: string
  cookie?: {
    [key: string]: any
  }
  [key: string]: any
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
  actions?: Array<{
    title: string
    tooltip: string
    icon: string
    color: string
    emit: string
  }>
}

interface TableData {
  columns: TableColumn[]
  rows: UserSession[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface DeviceData {
  [key: string]: any
}

interface DeleteResponse {
  success?: boolean
  [key: string]: any
}

interface CurrentUser {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'LOGGED_USERS',

  components: {
    scrollArea,
    scrollTable
  },

  props: {
    data: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
  },

  data(): {
    model: Record<string, any>
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      model: {},
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [
          {
            title: 'session id',
            value: 'id',
            type: 'text',
            width: '20%',
          },
          {
            title: 'user id',
            value: 'userId',
            type: 'text',
            width: '10%'
          },
          {
            title: 'session time',
            value: 'cookieExpires',
            type: 'text',
            width: '10%'
          },
          {
            title: 'role',
            value: 'role_nms',
            type: 'text',
            width: '20%'
          },
          {
            title: 'address',
            value: 'ip',
            type: 'text',
            width: '10%',
            actions: [
              {
                title: 'remove',
                tooltip: 'remove',
                icon: 'basket',
                color: 'green',
                emit: 'remove'
              },
            ],
          }
        ],
        rows: [],
      },
    }
  },

  computed: {
    getData(): DeviceData {
      return this.data
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.id?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.userId?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.ip?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },

    getOptions(): OptionsData {
      return this.options
    },

    ...mapGetters(['getCurrentUser']),
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadLoggedUsers()
    },

    async loadLoggedUsers(): Promise<void> {
      console.log(this.$options.name, 'loadLoggedUsers', 'START')
      try {
        // const loggedUsers = await this.$bridge.customQuery('alarm', 'auth/sessions', {}, 'get') as UserSession[]
        const loggedUsers = await this.$bridge.customQuery('core', 'auth/sessions', {}, 'GET') as UserSession[]

        console.log(this.$options.name, 'loadLoggedUsers', 'loggedUsers', loggedUsers)
        if (loggedUsers) {
          this.prepareTable(loggedUsers)
        }
      } catch (error) {
        console.error(this.$options.name, 'loadLoggedUsers smth wrong', error)
      }
    },

    async prepareTable(users: UserSession[]): Promise<void> {
      console.log(this.$options.name, 'prepareTable', 'users', users)
      try {
        const users$ = users.map(user => {
          if (user['cookie.expires']) {
            user.cookieExpires = user['cookie.expires']
            return user
            // return { ...user, ...user.cookie.expires }
          }
          return user
        })
        console.log(this.$options.name, 'prepareTable', 'users$', users$)
        if (users$.length) {
          this.table.rows = users$
        }
      } catch (error) {
        console.error(this.$options.name, 'prepareTable smth wrong', error)
      }
    },

    async onRemove(val: UserSession): Promise<void> {
      this.$dialog.confirm({
        text: `Удалить сеанс ${val.id}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: async () => {
              // const d = await this.$bridge.customQuery('alarm', `auth/session/${val.id}`, {}, 'delete') as DeleteResponse
              // console.log(this.$options.name, 'onRemove', 'val', val)
              // const d = await this.$bridge.customQuery('core', 'auth/session', {sessionId: val.id}, 'DELETE')
              const d = await this.$bridge.dropSession(val.id)
              console.log(this.$options.name, 'onRemove', 'd', d)
              if (d?.success) {
                this.$dialog.notify.success('Сеанс удалён', { timeout: 5000 })
              }
              if (val.userId === (this.getCurrentUser as CurrentUser).$id) {
                await this.$store.dispatch('unsubscribeAll')
                await this.$bridge.logout()
                this.$router.push({ name: 'login' })
              }
              console.log('removed', d)
              this.setup()
            }
          }
        }
      })
    },
  },
})
</script>

<style lang="css" scoped>
</style>
